import React, { useEffect, useState } from 'react';
import { Typography, Button, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';

let interval: any;

type PropTypes = {
  handleOpenChatClick: () => void;
  unreadChat: boolean;
};
export const BlinkingChatButton = ({
  handleOpenChatClick,
  unreadChat,
}: PropTypes) => {
  const [blinkChatIcon, setBlinkChatIcon] = useState(false);

  useEffect(() => {
    if (unreadChat) {
      startBlinkChat();
    } else {
      stopBlinkChat();
    }
  }, [unreadChat]);

  const startBlinkChat = () => {
    let currentState = false;
    setBlinkChatIcon(true);
    const startAnimation = () => {
      if (currentState) {
        setBlinkChatIcon(true);
      } else {
        setBlinkChatIcon(false);
      }
      currentState = !currentState;
    };
    interval = setInterval(startAnimation, 1000);
  };

  const stopBlinkChat = () => {
    setBlinkChatIcon(false);
    clearInterval(interval);
  };

  return (
    <Button
      variant="text"
      onClick={handleOpenChatClick}
      sx={{
        color: blinkChatIcon ? 'success.main' : 'none',
      }}
      startIcon={
        unreadChat ? (
          <MarkUnreadChatAltIcon
            sx={{ color: blinkChatIcon ? 'success.main' : 'none' }}
          />
        ) : (
          <ChatIcon
            sx={{
              color: 'primary.main',
            }}
          />
        )
      }
    >
      Chat
    </Button>
  );
};
